import { createBrowserRouter } from 'react-router-dom';
import { routes } from '../routes';
import * as Sentry from '@sentry/react';

const createRouter = window.__RUNTIME_CONFIG__?.SENTRY_DSN
  ? Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)
  : createBrowserRouter;

export const router = createRouter(routes, { window });
